<div class="request-password">
    <h1 id="title" class="title color-brand">{{ "REQUEST-PASSWORD.TITLE" | translate }}</h1>
    <p class="paragraph">
        {{ "REQUEST-PASSWORD.DESCRIPTION-1" | translate }} <br />
        {{ "REQUEST-PASSWORD.DESCRIPTION-2" | translate }}
    </p>
    <hr class="divider" />
    <nb-alert *ngIf="alert.show" [status]="alert.type" role="alert">
        {{ alert.message }}
    </nb-alert>
    <nb-stepper #stepper disableStepNavigation linear>
        <nb-step>
            <p class="paragraph">{{ "REQUEST-PASSWORD.SELECT-METHOD" | translate }}</p>

            <nb-radio-group
                class="row justify-content-center"
                [(ngModel)]="selectedMethod"
                (ngModelChange)="onMethodChange()"
            >
                <nb-radio
                    class="col-auto"
                    *ngFor="let method of (recoveryMethods$ | async)?.registers"
                    [value]="method"
                >
                    {{ method.descricao }}
                </nb-radio>
            </nb-radio-group>
            <form [formGroup]="form" (ngSubmit)="onRequestFind()" *ngIf="selectedMethod">
                <div class="form-control-group">
                    <label class="label">{{ selectedMethod.descricao }}</label>
                    <input nbInput type="text" formControlName="recovery_method" [mask]="mask" fullWidth />
                </div>
                <div class="d-flex justify-content-center">
                    <button nbButton type="submit">
                        {{ "GENERAL.SEND" | translate }} <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                    </button>
                </div>
            </form>
        </nb-step>
        <nb-step>
            <app-user-found
                *ngFor="let user of usersFound"
                [user]="user"
                [selection]="true"
                (select)="onUserSelect($event)"
            ></app-user-found>
            <nb-card *ngIf="!usersFound?.length">
                <nb-card-body>
                    <p class="paragraph">{{ "REQUEST-PASSWORD.NO-USER-FOUND" | translate }}</p>
                    <p class="paragraph">{{ "REQUEST-PASSWORD.CHECK-DATA" | translate }}</p>
                </nb-card-body>
            </nb-card>
            <div class="d-flex justify-content-center mt-2">
                <button nbButton fullWidth (click)="stepper.previous()" *ngIf="!usersFound?.length">
                    {{ "GENERAL.TRY-AGAIN" | translate }} <nb-icon icon="repeat-outline"></nb-icon>
                </button>
                <button
                    nbButton
                    fullWidth
                    (click)="stepper.next()"
                    [disabled]="!player"
                    *ngIf="usersFound?.length"
                    status="primary"
                >
                    {{ "BUTTONS.GO" | translate }} <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                </button>
            </div>
            <hr class="divider" />
            <nb-alert outline="basic" class="no-access-alert">
                <div class="no-access-alert-content">
                    <nb-icon
                        icon="alert-circle-outline"
                        class="mr-2 d-none d-md-inline-block"
                        style="font-size: 18px; flex-shrink: 0"
                    ></nb-icon>
                    <span>{{ "REQUEST-PASSWORD.NO-ACCESS" | translate }}</span>
                </div>
                <button nbButton status="basic" size="small" class="mr-2" routerLink="/auth/request-account-recover">
                    {{ "REQUEST-PASSWORD.NO-ACCESS-BTN" | translate }}
                </button>
            </nb-alert>
        </nb-step>
        <nb-step>
            <app-token-request
                type="0"
                [player]="player"
                (sent)="onTokenSent($event)"
                *ngIf="player"
            ></app-token-request>
        </nb-step>
        <nb-step>
            <app-token-validate
                type="2"
                [player]="player"
                [codeToken]="codeToken"
                [typeSending]="typeSending"
                (validate)="onValidationSuccess()"
                *ngIf="stepper.selectedIndex === 3"
            ></app-token-validate>
        </nb-step>
    </nb-stepper>
</div>
